import { z } from 'zod';

export const invitedSignupSchema = z
  .object({
    name: z.string().min(1, 'Name is required'),
    password: z.string().min(8, 'Password must be at least 8 characters'),
    confirmPassword: z.string().min(1, 'Please confirm your password'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  });

export type InvitedSignupFormValues = z.infer<typeof invitedSignupSchema>;

export const invitedSignupDefaults: InvitedSignupFormValues = {
  name: '',
  password: '',
  confirmPassword: '',
};
